/**
 * Created by Ning Jiang on 1/8/2020.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";
import {DeadwoodReelView} from "./DeadwoodReelView";

export class DeadwoodReelAreaView extends ReelAreaView {

    private _baseContainer:PIXI.Container;
    private _highContainer:PIXI.Container;
    private _winContainer:PIXI.Container;
    private _highWinContainer:PIXI.Container;

    private _baseMask:PIXI.Graphics;
    private _highMask:PIXI.Graphics;
    private _winMask:PIXI.Graphics;
    private _highWinMask:PIXI.Graphics;

    constructor() {
        super();

        this._baseContainer = new PIXI.Container();
        this._highContainer = new PIXI.Container();
        this._winContainer = new PIXI.Container();
        this._highWinContainer = new PIXI.Container();

        this._layer.addChild(this._baseContainer);
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.HIGH_SYMBOLS.name).addChild(this._highContainer);
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.WIN_SYMBOLS.name).addChild(this._winContainer);
        StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.HIGH_WIN_SYMBOLS.name).addChild(this._highWinContainer);
    }

    protected UpdateReelAreaMask():void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }

        if(this._baseMask) {
            this._baseMask.parent.removeChild(this._baseMask);
        }
        this._baseMask = this.getMaskShape();
        this._baseContainer.addChild(this._baseMask);
        this._baseContainer.mask = this._baseMask;

        if(this._highMask) {
            this._highMask.parent.removeChild(this._highMask);
        }
        this._highMask = this.getMaskShape();
        this._highContainer.addChild(this._highMask);
        this._highContainer.mask = this._highMask;

        if(this._winMask) {
            this._winMask.parent.removeChild(this._winMask);
        }
        this._winMask = this.getMaskShape();
        this._winContainer.addChild(this._winMask);
        this._winContainer.mask = this._winMask;

        if(this._highWinMask) {
            this._highWinMask.parent.removeChild(this._highWinMask);
        }
        this._highWinMask = this.getMaskShape();
        this._highWinContainer.addChild(this._highWinMask);
        this._highWinContainer.mask = this._highWinMask;
    }

    private getMaskShape():PIXI.Graphics {
        const rect:PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
                GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        maskShape.endFill();
        return maskShape;
    }

    protected onResize(resizeData:IResizeData):void {
        this._baseContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);
        this._highContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);
        this._winContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);
        this._highWinContainer.position.set(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y);

        this._reelViews.forEach((child:PIXI.Container, reelId:number) => {
            const reelView:DeadwoodReelView = <DeadwoodReelView>child;
            const position = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
            reelView.updatePositions(position[0], position[1]);
        });

        this.UpdateReelAreaMask();
    }

    public addReelView(reel:ReelController):void {
        super.addReelView(reel);

        const view:DeadwoodReelView = <DeadwoodReelView>reel.view;
        this._baseContainer.addChild(view.baseContainter);
        this._highContainer.addChild(view.highContainer);
        this._winContainer.addChild(view.winContainer);
        this._highWinContainer.addChild(view.highWinContainer);
    }
}